import { usePageTitle } from '@lib/common';
import React from 'react';
import { InHouseGuestReport } from '../components';

export const InHouseGuestPage: React.FC = () => {
  usePageTitle('In-House Guest Report');
  return <InHouseGuestReport />;
};
